import { type AxiosRequestConfig } from "axios";

import { $streemApiV1 } from "shared/boot/api";
import { type StreamRequestFilters } from "shared/helpers/StreamFilters";
import { type MentionType } from "shared/types/mentions";

interface MatchingSyndicationsResponse {
  syndications_matching_stream: {
    [id: number]: boolean;
  };
}

export const fetchMatchingSyndications = async ({
  filters = {},
  mentionId,
  mentionType,
  options,
  streamId,
}: {
  filters?: Partial<StreamRequestFilters>;
  mentionId: number;
  mentionType: MentionType;
  options?: Partial<AxiosRequestConfig>;
  streamId: number;
}): Promise<MatchingSyndicationsResponse["syndications_matching_stream"]> => {
  const response = await $streemApiV1.get<MatchingSyndicationsResponse>(
    `mentions/${mentionId}/syndications_matching_stream`,
    {
      params: {
        mention_type: mentionType,
        stream_id: streamId,
        ...filters,
      },
      ...options,
    }
  );

  return response.data.syndications_matching_stream;
};
